import { render, staticRenderFns } from "./ScaleQuestionV2.vue?vue&type=template&id=40717674&scoped=true&"
import script from "./ScaleQuestionV2.vue?vue&type=script&lang=js&"
export * from "./ScaleQuestionV2.vue?vue&type=script&lang=js&"
import style0 from "./ScaleQuestionV2.vue?vue&type=style&index=0&id=40717674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40717674",
  null
  
)

export default component.exports